import { toRecord } from '../../../utils/helper';
import { DataType, isFile, Tool, ToolJob } from '../../../utils/models/tool.models';
import { InputMapping } from '../../../utils/models/toolchain.models';

export type InputMappingWithValue = InputMapping & {
  outputValue: DataType | DataType[];
};

export function isInputMappingWithValue(input: InputMapping): input is InputMappingWithValue {
  return (input as Partial<InputMappingWithValue>).outputValue !== undefined;
}

export function fillInputMapping(
  previousJob: ToolJob,
  tool: Tool,
  mappings: InputMapping[],
  populatedOutputs?: Record<string, unknown>
): InputMapping[] {
  if (previousJob.status !== 'Done' || typeof previousJob.results === 'string') return mappings;

  const results = toRecord(previousJob.results);
  return mappings.map(mapping => {
    if (!(mapping.outputName in results)) return mapping;

    const input = tool.inputs.find(input => input.name === mapping.inputName);
    if (!input) return mapping;

    let outputValue = results[mapping.outputName];
    if (isFile(input.param)) {
      if (!populatedOutputs || !(mapping.outputName in populatedOutputs)) return mapping;
      outputValue = populatedOutputs[mapping.outputName];
      if (!input.isList && Array.isArray(outputValue) && outputValue.length > 0) {
        outputValue = outputValue[0];
      }
    }

    return { ...mapping, outputValue: outputValue as DataType | DataType[] };
  });
}

export function requiresPopulatedOutputs(
  previousJob: ToolJob,
  tool: Tool,
  mappings: InputMapping[]
): boolean {
  if (previousJob.status !== 'Done' || typeof previousJob.results === 'string') return false;

  const results = toRecord(previousJob.results);
  return mappings.some(mapping => {
    const input = tool.inputs.find(input => input.name === mapping.inputName);
    return mapping.outputName in results && !!input && isFile(input.param);
  });
}
